import { useEffect, useMemo } from "react"

import { useAppDispatch } from "../../../hooks/use-app-dispatch.ts"
import { useAppSelector } from "../../../hooks/use-app-selector.ts"
import { knownFolderNames } from "../helpers/reportFolders.ts"
import { fetchReportFolders } from "../redux/reports.thunks.ts"

/** Every folder a report can be filed into, for pickers outside the Reports
 * sidebar (the wizard, the settings modal on a deep-linked report). */
export const useReportFolderNames = (): string[] => {
  const dispatch = useAppDispatch()
  const reports = useAppSelector((s) => s.reports.results)
  const folders = useAppSelector((s) => s.reports.folders)
  const foldersStatus = useAppSelector((s) => s.reports.foldersStatus)

  useEffect(() => {
    if (foldersStatus === "idle") void dispatch(fetchReportFolders())
  }, [dispatch, foldersStatus])

  return useMemo(() => knownFolderNames(reports, folders), [reports, folders])
}
